import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetKYCstatusAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const kycStatus = createAsyncThunk('get/kycStatus', GetKYCstatusAPI);

export const CheckKycStatusSlice = createSlice({
	name: 'kycStatus',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[kycStatus.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[kycStatus.rejected.toString()]: setAPIError,
		[kycStatus.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[CheckKycStatusSlice.name]: ReturnType<typeof CheckKycStatusSlice.reducer>;
}

export const kycStatusSelector = (state: IStates): any => {
	return state[CheckKycStatusSlice.name] || {};
};

export const useKycStatus = (): any => useSelector(kycStatusSelector);

export const checkKycStatus =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(kycStatus());
		return;
	};

export const resetKycStatus =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(CheckKycStatusSlice.actions.RESET());
		return;
	};
